import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { StatusIcon } from 'src/components/ui/status-icon/NoonReportStatusIcon.styles';
import { BunkeringDateStatusEnum } from 'src/enums/bunkering/bunkeringDateStatusEnum';

export const BunkeringDateStatusIcon = (dateStatus: BunkeringDateStatusEnum) => {
    switch (dateStatus) {
        case BunkeringDateStatusEnum.unregisteredBunkering:
            return (
                <StatusIcon className="status-icon status-missing">
                    <FontAwesomeIcon icon="gas-pump" title="Unregistered bunkering" />
                </StatusIcon>
            );
        case BunkeringDateStatusEnum.registeredBunkering:
            return (
                <StatusIcon className="status-icon status-incomplete">
                    <FontAwesomeIcon icon="gas-pump" title="Registered bunkering (awaiting approval)" />
                </StatusIcon>
            );
        case BunkeringDateStatusEnum.approvedOrInUseBunkering:
            return (
                <StatusIcon className="status-icon status-approved">
                    <FontAwesomeIcon icon="gas-pump" title="Approved bunkering" />
                </StatusIcon>
            );
        case BunkeringDateStatusEnum.spentBunkering:
            return (
                <StatusIcon className="status-icon status-saved">
                    <FontAwesomeIcon icon="gas-pump" title="Spent bunkering" />
                </StatusIcon>
            );
        case BunkeringDateStatusEnum.rejectedBunkering:
            return (
                <StatusIcon className="status-icon status-incomplete">
                    <FontAwesomeIcon icon="gas-pump" title="Rejected bunkering" />
                </StatusIcon>
            );
        case BunkeringDateStatusEnum.debunkered:
            return (
                <StatusIcon className="status-icon status-saved">
                    <FontAwesomeIcon icon="gas-pump" title="Debunkered" />
                </StatusIcon>
            );
    }
};

export default BunkeringDateStatusIcon;
